"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requestEpic = void 0;

var _js = require("@agile-actors/actions/dist/js");

var _operators = require("./operators");

var requestEpic = function requestEpic(action$) {
  return action$.pipe((0, _operators.ofType)(_js.request.type), (0, _operators.resolveRequest)());
};

exports.requestEpic = requestEpic;